export default __webpack_public_path__ + "static/autocinema_logo-228a214753f07199ea1e4a2e6e80b217.svg";